import moment from 'moment';
import { Column } from "material-table";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IBookingType } from 'common/src/types';
import { CustomMaterialTable } from 'components/CustomMaterialTable';

const BookingHistory = () => {
  const { t } = useTranslation();
  const settings = useSelector(state => state.settingsdata.settings);
  const bookinglistdata = useSelector(state => state.bookinglistdata);


  if (!settings) return;

  const columns: Column<IBookingType>[] = [
    { title: t('booking_id'), field: 'id' },
    { title: t('booking_ref'), field: 'reference' },
    { title: t('booking_date'), field: 'bookingDate', render: rowData => rowData.bookingDate ? moment(rowData.bookingDate).format('DD/MM/YYYY HH:mm') : null },
    { title: t('trip_start_time'), field: 'tripdate', render: rowData => rowData.tripdate ? moment(rowData.tripdate).format('DD/MM/YYYY HH:mm') : null },
    { title: t('car_type'), field: 'carType' },
    { title: t('customer_name'), field: 'customer_name' },
    { title: t('pickup_address'), field: 'pickupAddress' },
    { title: t('drop_address'), field: 'dropAddress' },
    { title: t('assign_driver'), field: 'driver_name' },
    { title: t('booking_status'), field: 'status', render: rowData => <span>{t(rowData.status)}</span> },
    { title: t('cancellation_reason'), field: 'reason' },
    { title: t('cancellationFee'), render: rowData => <span>{rowData.cancellationFee ? rowData.cancellationFee : (0).toFixed(settings.decimal)}</span> },
    { title: t('otp'), field: 'otp' },
    { title: t('trip_cost'), field: 'trip_cost' },
    { title: t('trip_start_time'), field: 'trip_start_time' },
    { title: t('trip_end_time'), field: 'trip_end_time' },
    { title: t('total_time'), field: 'total_trip_time' },
    { title: t('distance'), field: 'distance' },
    { title: t('vehicle_no'), field: 'vehicle_number' },
    { title: t('trip_cost_driver_share'), field: 'driver_share' },
    { title: t('convenience_fee'), field: 'convenience_fees' },
    { title: t('discount_ammount'), field: 'discount' },
    { title: t('Customer_paid'), field: 'customer_paid' },
    {
      field: 'payment_mode',
      title: t('payment_mode'),
      render: rowData => <span>{t((rowData.real_payment_mode) as any)}</span>,
    },
  ];




  return (
    <CustomMaterialTable
      data={bookinglistdata.bookings ?? []}
      title={'booking_title'}
      columns={columns}
    />
  );
}

export default BookingHistory;